const mq = {
  mobile: "@media screen and (max-width: 30em)",
};

export default mq;
